import React from 'react';
import { Col, Container, Label, Row } from 'reactstrap';
import DatePicker from "react-datepicker";
import moment from 'moment';
import Select from 'react-select';
import { mustBeArray } from '../../utils/lib';
import { apiRequest } from '../../utils/request';
import { getClientRequestStatusLabel } from '../../utils';

const fetchClientsAndLocations = (input) => {
    return apiRequest(`/api/clientrequests/client-location-search?term=${encodeURIComponent(input || '')}`)
        .then(x => {
            return {
                options: mustBeArray(x && x.data),
            };
        });
};

const clientLocationOptionRenderer = (option) => (
    <span>{option.name} <small className="text-muted">&mdash; {option.entityType}</small></span>
);

const ClientRequestFilters = props => {
    const {handleFilterChange, filters, handleResetFilter, handleSearch, statusList, requestTypes,
            selectedClientLocations, handleClientLocationChange, handleExportCsv} = props;
    return(
        <Container>
            <Row className="align-items-center mb-1">
                <Col sm={4} md={3}>
                    <Label for="clientLocationSearch">Client/Location</Label>
                </Col>
                <Col sm={8} md={9}>
                    <Select.Async
                        name="clientLocationSearch"
                        multi={true}
                        simpleValue={false}
                        clearable={true}
                        loadOptions={fetchClientsAndLocations}
                        onChange={handleClientLocationChange}
                        value={selectedClientLocations}
                        valueKey="id"
                        labelKey="name"
                        optionRenderer={clientLocationOptionRenderer}
                        placeholder="Search clients and locations"
                        searchable={true}
                        autoload={false}
                    />
                </Col>
            </Row>

            <Row className="align-items-center mb-1" >
                <Col sm={4} md={3}>
                    <Label for="requestTypeIds">Request Type</Label>
                </Col>
                <Col sm={8} md={9}>
                    <Select
                        name="requestTypeIds"
                        value={filters.requestTypeIds}
                        multi={true}
                        clearable={true}
                        simpleValue={true}
                        options={mustBeArray(requestTypes)}
                        onChange={(value) => handleFilterChange({value, field: "requestTypeIds", isMulti: true})}
                        valueKey="id"
                        labelKey="name"
                    />
                </Col>
            </Row>
            <Row className="align-items-center mb-1" >
                <Col sm={4} md={3}>
                    <Label for="requestStatusIds">Status</Label>
                </Col>
                <Col sm={8} md={9}>
                    <Select
                        name="requestStatusIds"
                        value={filters.requestStatusIds}
                        multi={true}
                        clearable={true}
                        simpleValue={true}
                        options={mustBeArray(statusList).map(s => ({...s, name: getClientRequestStatusLabel({statusId: s.id, fallbackName: s.name})}))}
                        onChange={(value) => handleFilterChange({value, field: "requestStatusIds", isMulti: true})}
                        valueKey="id"
                        labelKey="name"
                    />
                </Col>
            </Row>
            <Row className="align-items-center full-width-datepicker">
                <Col sm={4} md={3} >
                    <Label for="from" >From</Label>
                </Col>
                <Col sm={8} md={4} className="mb-1">
                    <DatePicker
                        onChange={(date) => handleFilterChange({value: date, field: 'dateFrom'})}
                        value={filters.dateFrom || undefined}
                        openToDate={filters.dateFrom ? moment(filters.dateFrom) : moment()}
                        placeholderText="Date From"
                        locale="en-au"
                        readOnly={false}
                        popperPlacement="bottom-end"
                        popperModifiers={{
                        offset: {
                            enabled: true,
                            offset: '5px, 10px'
                        },
                        preventOverflow: {
                            enabled: true,
                            escapeWithReference: false,
                            boundariesElement: 'viewport'
                        }
                        }}
                        className="form-control"
                    />
                </Col>
                <Col sm={4} md={1}>
                    <Label for="to" >To</Label>
                </Col>
                <Col sm={8} md={4} className="mb-1">
                    <DatePicker
                        onChange={(date) => handleFilterChange({value: date, field: 'dateTo'})}
                        value={filters.dateTo || undefined}
                        openToDate={filters.dateTo ? moment(filters.dateTo) : moment()}
                        placeholderText="Date To"
                        locale="en-au"
                        readOnly={false}
                        popperPlacement="bottom-end"
                        popperModifiers={{
                        offset: {
                            enabled: true,
                            offset: '5px, 10px'
                        },
                        preventOverflow: {
                            enabled: true,
                            escapeWithReference: false,
                            boundariesElement: 'viewport'
                        }
                        }}
                        className="form-control"
                        minDate={filters.dateFrom ? moment(filters.dateFrom) : moment()}
                    />
                </Col>
            </Row>
            <div className="mt-2">
                <button className="btn btn-primary" onClick={handleSearch}>
                    <i className="fa fa-search" aria-hidden="true"></i> &nbsp;Search
                </button>
                <button className="btn btn-default ml-1" onClick={handleResetFilter}>Reset</button>
                <button className="btn btn-success ml-1" onClick={handleExportCsv}>Export CSV</button>
            </div>
        </Container>
    );
};
export default ClientRequestFilters;
